'use client'

import { create } from 'zustand'

import type { MarketingConsentsValues } from 'modules/customer'

import { PaymentMethod } from '../types'

interface CheckoutPaymentFormState {
  paymentMethodId: string | null
  paymentMethodName: string | null
  blikCode: string
  blikValid: boolean
  rulesAccepted: boolean
  marketingConsents: MarketingConsentsValues
}

export interface CheckoutPaymentState extends CheckoutPaymentFormState {
  paymentMethod: PaymentMethod | null
  selectPaymentMethod: (method: PaymentMethod) => void
  setBlikCode: (blikCode: string) => void
  setBlikValid: (blikValid: boolean) => void
  setRulesAccepted: (rulesAccepted: boolean) => void
  setMarketingConsents: (marketingConsents: MarketingConsentsValues) => void
  resetForm: () => void
}

const initialFormState: CheckoutPaymentFormState = {
  paymentMethodId: null,
  paymentMethodName: null,
  blikCode: '',
  blikValid: false,
  rulesAccepted: false,
  marketingConsents: {
    smsConsentsGranted: false,
    isNewsletterSubscriber: false
  }
}

export const useCheckoutPaymentStore = create<CheckoutPaymentState>()(set => ({
  ...initialFormState,
  paymentMethod: null,
  selectPaymentMethod: method =>
    set({
      paymentMethodId: method.id,
      paymentMethodName: method.name,
      blikCode: '',
      paymentMethod: method
    }),
  setBlikCode: blikCode => set({ blikCode }),
  setBlikValid: blikValid => set({ blikValid }),
  setRulesAccepted: rulesAccepted => set({ rulesAccepted }),
  setMarketingConsents: marketingConsents => set({ marketingConsents }),
  resetForm: () => set(initialFormState)
}))
